import { Resources } from 'constants/resources';

import { blue } from '@mui/material/colors';
import { useCreatePathWithQuery } from 'hooks/useCreatePathWithQuery';
import { Link } from 'react-router-dom';
import { FunctionField } from 'shared/react-admin/Fields';
import { WorkTeam } from 'types/embedded/workTeam';

type Props = {
  label: string;
  source: string;
};

export const WorkTeamsListNameField: React.FunctionComponent<Props> = ({ label, source }) => {
  const { createPathWithQuery } = useCreatePathWithQuery();

  return (
    <FunctionField
      label={label}
      render={(record: WorkTeam) => (
        <Link
          style={{ color: blue[700], fontSize: 14 }}
          to={createPathWithQuery({
            resource: Resources.WorkTeams,
            id: record?.id,
            type: 'show',
          })}
        >
          {record?.name}
        </Link>
      )}
      source={source}
    />
  );
};
